export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
                随时随地 免费观影
              </h2>
              <p className="text-background-50/80 text-sm leading-relaxed mb-6">
                蘑菇影院完美适配手机与平板，无论在家还是通勤路上，打开浏览器即可畅享高清影视。无需下载APP，节省手机空间，全网影视资源触手可及。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <a
                  href="#cards"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-primary-600 font-semibold text-sm rounded-lg hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-smartphone-line"></i>
                  手机端体验
                </a>
                <a
                  href="#ranking"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-600/40 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600/60 border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-fire-line"></i>
                  热门推荐
                </a>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-3xl bg-background-50/20 backdrop-blur flex items-center justify-center">
                <span className="text-6xl">📱</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}